import { axiosPrivate } from "../api/axios";

const URL= '/perfil'


const obtenerPerfil = async () => {
    try {
        const response = await axiosPrivate.get(URL,
            );
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response);
        throw new Error(error);
    }
};

const editarPerfil = async ({data, avatar}) => {
    try {
        const response = await axiosPrivate.put(URL,
            {...data, avatar}
            );
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response?.data?.error);
        throw new Error(error.response?.data?.error);
    }
};


const eliminarPerfil = async (data) => {
    try {
        const response = await axiosPrivate.delete(URL,
            data
            );
        console.log(response);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.response?.data?.error);
    }
};
const PerfilService={
    obtenerPerfil,
    editarPerfil,
    eliminarPerfil
}

export default PerfilService;
